import React, {useState, useEffect} from 'react';
import OaCard from 'oahoc/OaCard';
import MobileSearchForm from './MobileSearchForm';


const MobileSearch = (props) => <MobileSearchForm />;

export default MobileSearch;
